import "./utilities_namespace.js";

// Formats an appointment date, using `formatWithYear` on the terms `showYear` sets: "never",
// "next_year" (any year but the current one) or "always". An unrecognized value states no year.
//
// `showYear` is an argument rather than state on this function because every bundle that requires
// this file evaluates its own copy of it, so a stored value is reset by whichever bundle loads last.
//
// Both formats are supplied because the year's position and its preposition are locale-specific —
// Portuguese reads "24 de março de 2027" — so the year cannot be appended to a base pattern.
window.Sparkle.Utilities.appointmentDate = function (momentDate, showYear, format, formatWithYear) {
  function statesYear() {
    if (showYear === "always") {
      return true;
    }

    if (showYear === "next_year") {
      return momentDate.year() !== moment().year();
    }

    return false;
  }

  return momentDate.format(statesYear() ? formatWithYear : format);
};
